import React from 'react'
import moment from 'moment'
import {removeZeros} from '../../../utils/misc'
import {getUserSettings} from '../../../storage'
class CreditA4 extends React.Component {

  render() {

    let company = this.props.company
    let credit = this.props.credit
    let settings = getUserSettings()

    let credit_date = moment(credit.date).format('D-MM-YYYY')
    let billto
    let shipping_address
    let optionalRow


    if(typeof credit.client !== "undefined" && credit.client !== null) {

      let client_gstin

      if(typeof credit.client.gstin !== "undefined" && credit.client.gstin !== null) {
        client_gstin = "GSTIN-"+credit.client.gstin
      }
      if(!credit.client.same_as_biiling) {
        shipping_address = <div>  <div className="gray">
                {credit.client.name}
          </div>
          <div className="gray">
              {credit.client.shipping_address}
          </div>
          <div className="gray">
              {credit.client.shipping_city}
          </div>
          <div className="gray">
              {credit.client.shipping_state}-{credit.client.shipping_pin}
          </div></div>
      }
      else {
        shipping_address = <div>  <div className="gray">
                {credit.client.name}
          </div>
          <div className="gray">
              {credit.client.address}
          </div>
          <div className="gray">
              {credit.client.city}
          </div>
          <div className="gray">
              {credit.client.state}-{credit.client.pin}
          </div></div>
      }

      billto = <div className="row">
      <div className="col-xs-6">
        <div className="">
        <strong>Bill To</strong>
          <div className="gray">
              {credit.client.name}
          </div>
          <div className="gray">
              {credit.client.address}
          </div>
          <div className="gray">
              {credit.client.city}
          </div>
          <div className="gray">
              {credit.client.state}-{credit.client.pin}
          </div>
          <div className="gray">
             {client_gstin}
          </div>
        </div>
      </div>

      <div className="col-xs-6">
        <div className="">
        <strong>Ship To</strong>
          {shipping_address}
        </div>
      </div>

      </div>

    }


    let items

    if(credit.retnitem_set.length > 0) {
      items = credit.retnitem_set.map((saleitem, index)=>{
        let discountCol, cgstcol, sgstcol, igstcol
        if(saleitem.discount_value > 0) {
            discountCol = <td className="text-right">{removeZeros(saleitem.discount_value)}</td>
        }
        else {
          discountCol = <td className="text-right"></td>
        }

        if(credit.is_igst) {
          if(saleitem.igst_amount > 0) {
            igstcol = <td className="text-right">
              {Number(saleitem.igst_amount)} ({Number(saleitem.gst.igst)}%)

                 </td>
          }
          else {
            igstcol = <td className="text-right"></td>
          }

        }
        else {

          if(saleitem.cgst_amount > 0) {
            cgstcol=  <td className="text-right">
            {Number(saleitem.cgst_amount)} ({Number(saleitem.gst.cgst)}%)
               </td>
          }
          else {
            cgstcol= <td className="text-right"></td>
          }

          if(saleitem.sgst_amount > 0) {
            sgstcol= <td className="text-right">
                      {Number(saleitem.sgst_amount)} ({Number(saleitem.gst.sgst)}%)
                 </td>
          }
          else {
            sgstcol = <td className="text-right"></td>
          }
        }

        let item_unit

        let unit_price = Number(saleitem.selling_basic_rate),
        taxable_price = Number(saleitem.price),
        item_total = Number(saleitem.total)


        return <tr key={index}>
          <td>{saleitem.tableIndex}</td>
          <td><div>{saleitem.name}</div></td>
          <td><div>{saleitem.hsn}</div> </td>
          <td className="text-right">
            <div>{Number(saleitem.quantity)}</div>
            <div>{item_unit}</div>
            </td>
          <td className="text-right">{unit_price}</td>
          {discountCol}
          <td className="text-right">{taxable_price}</td>
            {cgstcol}{sgstcol}{igstcol}
          <td className="text-right">{item_total}</td>
      </tr>
      })
    }

    let discount
    if(credit.totalDiscount > 0) {
      discount = <div className="row">
          <div className="col-xs-6">
            <strong>Discount  </strong>
          </div>
          <div className="col-xs-6 text-right">
             &#8377; {credit.totalDiscount}
          </div>
      </div>
    }

    let totalBeforeDiscount = parseFloat(parseFloat(credit.totalPrice) + parseFloat(credit.totalDiscount)).toFixed(2)

    let cgst_header, sgst_header, igst_header
    if(credit.is_igst) {
      igst_header = <th className="text-right">IGST</th>
    }
    else {
      cgst_header = <th className="text-right">CGST</th>
      sgst_header = <th className="text-right">SGST</th>

    }

    let serial = credit.serial, credit_label = "CREDIT NOTE"

    if(typeof credit.client_bill_no !== "undefined" && credit.client_bill_no.length > 0) {
      serial = credit.client_bill_no
    }
    else {
      if(typeof settings !== "undefined" && settings.credit_serial_prefix.length > 0) {
        serial = settings.credit_serial_prefix+serial
      }
    }

    let invoice_serial

    if(credit.invoice){
      invoice_serial = "Invoice: " + credit.invoice.series_name + credit.invoice.series_counter
    }


    if(typeof settings !== "undefined" && settings !== null) {

      if(settings.credit_label) {
        credit_label = <span>{settings.credit_label}</span>
      }

        let declartion, bankDetails, pan
        if(settings.show_credit_pan) {
          pan = <div>Company Pan - {company.pan}</div>
        }
        if(settings.show_credit_declaration) {
          declartion = <div><u>Terms and Conditions</u>
              <div><p>{settings.credit_declaration}</p></div>
      </div>
        }

        if(settings.show_credit_bankdetails) {
          bankDetails = <div><div className="row">
              <div className="col-xs-6">Bank Name</div>
              <div className="col-xs-6">{company.bank_name}</div>
              </div>
              <div className="row">
                <div className="col-xs-6">Account No</div>
                <div className="col-xs-6">{company.account_no}</div>
              </div>
              <div className="row">
                <div className="col-xs-6">IFSC</div>
                <div className="col-xs-6">{company.ifsc_code}</div>
              </div>
              <div className="row">
                <div className="col-xs-6">Branch </div>
                <div className="col-xs-6">{company.branch_name}</div>
              </div>

              </div>
        }
        optionalRow = <div className="row space-medium small" >
          <div className="col-xs-6">
            {pan}
            {declartion}
          </div>
          <div className="col-xs-6">
            {bankDetails}
          </div>
        </div>


    }


      return <div  className="preview-a4" >

              <div className="row">
                <div className="col-xs-6">
                  <div className="company-name text-uppercase">
                    {company.company_name}
                  </div>
                  <div className="">
                  <div className="company-address gray">
                    {company.address}, <span className="company-city gray">{company.city}</span>
                  </div>
                  <div className="company-state gray">
                    {company.state} - <span className="company-pin gray">{company.pin}</span>
                  </div>
                  <div className="company-email gray">
                    {company.email}
                  </div>
                  <div className="company-phone gray">
                    {company.phone}
                  </div>
                  <div className="company-state gray">
                   GSTIN - {company.gstin}
                  </div>
                  </div>

                </div>
                <div className="col-xs-6">
                <div className="invoice-name text-right">
                  {credit_label}
                </div>

                <div className="text-right invoice-name">{serial}</div>
                  <div className="text-right">
                    {invoice_serial}
                  </div>
                  <div className="gray text-right">
                  Date: {credit_date}
                  </div>
                </div>

              </div>

              <hr/>

              {billto}

              <div className="row space-medium">
              <div className="col-xs-12">
              <table className="table table-bordered table-condensed">
                <thead>
                  <tr className="active">
                    <th>S.No</th>
                    <th className="table-item">Item Name</th>
                    <th className="table-item">HSN</th>
                    <th className="text-right">Qty</th>
                    <th className="text-right">Unit Price</th>
                    <th className="text-right">Discount</th>
                    <th className="text-right">Taxable Price</th>
                    {cgst_header}{sgst_header}{igst_header}
                    <th className="text-right">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {items}
                </tbody>

              </table>
              </div>
              </div>


              <div className="row space-small">
              <div className="col-xs-6 col-xs-offset-6">

                  <div className="row">
                      <div className="col-xs-6">
                        <strong>Amount  </strong>
                      </div>
                      <div className="col-xs-6 text-right">
                         &#8377; {totalBeforeDiscount}
                      </div>
                  </div>

                  {discount}

                  <div className="row">
                      <div className="col-xs-6">
                        <strong>GST  </strong>
                      </div>
                      <div className="col-xs-6 text-right">
                         &#8377; {credit.totalTax}
                      </div>
                  </div>

                  <div className="row">
                      <div className="col-xs-6">
                      <strong>Total  </strong>
                      </div>
                      <div className="col-xs-6 text-right">
                         &#8377; {credit.total}
                      </div>
                  </div>

              </div>
              </div>

              {optionalRow}

              <div className="row space-small">
              <div className="col-xs-6 col-xs-offset-6">

              <div className=" text-center">
              Authorized Signature
              </div>
              </div>
              </div>


      </div>

  }
}

export default CreditA4



// WEBPACK FOOTER //
// ./src/components/credit/previews/credita4.js